import axios from '../utils/index'
import axios1 from 'axios'

// 检索条件查询
export function listSearchParam(params) {
  return axios.post('/portal/book/listSearchParam', params)
}

export function mainSearch(data) {
  return axios1({
    method: 'post',
    url: '/portal/book/mainSearch',
    data: data,
    headers: {'Content-Type': 'application/json'}
  });
}

//统计查询接口 资源 左 数据
export function listStatistics(params) {
  return axios.get('/portal/statistics/listStatistics', {params})
}

//前台查询元数据模版列表接口
export function listCategory(params) {
  return axios.get('/portal/category/listCategory', {params})
}

//获取子库名称
export function getDictDataByType(params) {
  return axios.get('/portal/dictionaryCache/getDictDataByType', {params})
}

//书籍详情
export function getBookById(params) {
  return axios.get('/portal/book/getBookById', {params})
}

// 主从目录
export function getMasterSlaveCatalogue(params) {
  return axios.get('/portal/book/getMasterSlaveCatalogue', {params})
}

/**
 * 查询馆信息
 * @param params
 * @returns {*}
 */
export function getLibraryById(params) {
  return axios.get('/portal/library/getLibraryById', {params})
}

/**
 * 查询馆信息
 * @param params
 * @returns {*}
 */
export function listBookRelationByBookId(params) {
  return axios.get('/portal/relation/listBookRelationByBookId', {params})
}

/**
 * 查询馆信息
 * @param params
 * @returns {*}
 */
export function listWordView(params) {
  return axios.get('/portal/word/listWordView', {params})
}

/**
 * 新增阅读记录
 * @param params
 * @returns {*}
 */
export function addReadHistory(params) {
  return axios.post('/portal/history/addReadHistory', params)
}
